__turbopack_context__.v({
  "column": "FinishingPoints-module-scss-module__vKm6CW__column",
  "columns": "FinishingPoints-module-scss-module__vKm6CW__columns",
  "image": "FinishingPoints-module-scss-module__vKm6CW__image",
  "imageBox": "FinishingPoints-module-scss-module__vKm6CW__imageBox",
  "imageDescription": "FinishingPoints-module-scss-module__vKm6CW__imageDescription",
  "number": "FinishingPoints-module-scss-module__vKm6CW__number",
  "point": "FinishingPoints-module-scss-module__vKm6CW__point",
  "text": "FinishingPoints-module-scss-module__vKm6CW__text",
  "title": "FinishingPoints-module-scss-module__vKm6CW__title",
});
